import React from "react";
import PropTypes from "prop-types";
import { StyledButton } from "./index.styles";
import theme from "../../theme";

const defaultProps = {
  backgroundColor: theme.colors.blue,
  borderColor: "",
  fullWidth: false,
  textColor: theme.colors.white,
  outlined: false,
  disabled: false,
};

/**
 * A simple button
 */
export const Button = ({
  backgroundColor,
  borderColor,
  children,
  disabled,
  fullWidth,
  onClick,
  sx,
  textColor,
  outlined,
}) => {
  return (
    <StyledButton
      disabled={disabled}
      backgroundcolor={backgroundColor}
      bordercolor={borderColor !== "" ? borderColor : 'none'}
      disableElevation
      fullWidth={fullWidth}
      onClick={onClick}
      sx={sx}
      textcolor={textColor}
      variant={outlined ? "outlined" : "contained"}
    >
      {children}
    </StyledButton>
  );
};

Button.propTypes = {
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  textColor: PropTypes.string,
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
  outlined: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  sx: PropTypes.object.isRequired,
};

Button.defaultProps = defaultProps;

export default Button;
